import { render, staticRenderFns } from "./CompetitivePricingScreen.vue?vue&type=template&id=27dc6c78"
import script from "./CompetitivePricingScreen.vue?vue&type=script&lang=js"
export * from "./CompetitivePricingScreen.vue?vue&type=script&lang=js"
import style0 from "./CompetitivePricingScreen.vue?vue&type=style&index=0&id=27dc6c78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports